export const numberValueTypes = {
    numberOfPatrons: { id: "numberOfPatrons", name: "Visitors" },
    numberOfReturnPatrons: { id: "numberOfReturnPatrons", name: "Area Visits (Returning)" },
    numberOfNewPatrons: { id: "numberOfNewPatrons", name: "Area Visits (New)" },
    dwellTime: { id: "dwellTime", name: "Dwell Time" },
    seeTicketsCount: { id: "seeTicketsCount", name: "See Tickets Scan Count" },
    posTerminalSum: { id: "posTerminalSum", name: "POS Purchases" },
    soldTicketsCount: { id: "soldTicketsCount", name: "Sold Tickets Count" },
};